import { useEffect } from "react";
import { useAppSelector } from "../store/store";
import { QuestionResponse, User } from "../types";

interface SurveyDataHook {
    question: QuestionResponse | null;
    user?: Partial<User> | null;
    language?: "EN" | "ES";
    answersDeclined?: boolean | null;
}

export const useSurveyData = (
    setSelectedAnswers: React.Dispatch<React.SetStateAction<number[]>>, setErrorMessage: React.Dispatch<React.SetStateAction<string | null>>): SurveyDataHook =>{
        const language = useAppSelector(state => state.lang.language)
        const user = useAppSelector(state => state.user.user)
        const answersDeclined = useAppSelector(state=> state.survey.allAnswersDeclined)
        const question = useAppSelector(state => state.survey.survey)

        useEffect(() => {
          const hasPreviousAnswer = question?.PreviousAnswer != null;
          
          if (hasPreviousAnswer && question?.PreviousAnswer){
            setSelectedAnswers([...question.PreviousAnswer])
          }else{
            setSelectedAnswers([])
          }
          setErrorMessage(null)
        }, [question?.QuestionOrder, question?.PreviousAnswer, question?.Choice, setSelectedAnswers, setErrorMessage])
        return {question, user, language, answersDeclined}
    }